// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2XJtg","infoBtn":"quickbooks_infoBtn__2wUSJ","formBox":"quickbooks_formBox__2Igcq","formFooter":"quickbooks_formFooter__3XDCc"};